import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getFormComponents({ commit }) {
      try {
        const response = await api.get(`/params/form-components`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
